import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import { APP_AUTH, AuthProvider } from 'config';
import AuthLayout from 'layout/Auth';

// jwt auth
const JwtAuthLogin = Loadable(lazy(() => import('pages/auth/jwt/login')));
const JwtAuthRegister = Loadable(lazy(() => import('pages/auth/jwt/register')));
const JwtAuthForgotPassword = Loadable(lazy(() => import('pages/auth/jwt/forgot-password')));
const JwtAuthResetPassword = Loadable(lazy(() => import('pages/auth/jwt/reset-password')));
const JwtAuthCodeVerification = Loadable(lazy(() => import('pages/auth/jwt/code-verification')));
const JwtAuthCheckMail = Loadable(lazy(() => import('pages/auth/jwt/check-mail')));

// entra auth
const EntraAuthLogin = Loadable(lazy(() => import('pages/auth/entra/login')));

// render - maintenance
const MaintenanceError403 = Loadable(lazy(() => import('pages/maintenance/403')));
const MaintenanceError404 = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError429 = Loadable(lazy(() => import('pages/maintenance/429')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        {
          path: APP_AUTH === AuthProvider.JWT ? '/' : 'jwt',
          children: [
            { path: 'login', element: <JwtAuthLogin /> },
            { path: 'register', element: <JwtAuthRegister /> },
            { path: 'forgot-password', element: <JwtAuthForgotPassword /> },
            { path: 'check-mail', element: <JwtAuthCheckMail /> },
            { path: 'reset-password', element: <JwtAuthResetPassword /> },
            { path: 'code-verification', element: <JwtAuthCodeVerification /> }
          ]
        },
        {
          path: APP_AUTH === AuthProvider.ENTRA ? '/' : 'entra',
          children: [
            { path: '/', element: <EntraAuthLogin /> },
            { path: 'login', element: <EntraAuthLogin /> }
          ]
        }
      ]
    },
    {
      path: '/maintenance',
      children: [
        {
          path: '403',
          element: <MaintenanceError403 />
        },
        {
          path: '404',
          element: <MaintenanceError404 />
        },
        {
          path: '429',
          element: <MaintenanceError429 />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        }
      ]
    }
  ]
};

export default LoginRoutes;
